import {
    CapHistory
} from '../features/models/api/api-types';

export function toCapHistory(cap: CapHistory): CapHistory | null {
    return {
        ...cap,        
        capId: cap.capId,
        name: cap.name,
        amount: cap.amount,
        period: cap.period,
        activeStart: cap.activeStart,
        activeEnd: cap.activeEnd,
        origins: cap.origins,
        states: cap.states,
        customerTypes: cap.customerTypes,
        startedOn: cap.startedOn,
        endedOn: cap.endedOn
    };
}

